<template>
  <div>
    <NavBar />
    <NewRecurrence @created="getRecurrences()" />
    <ViewRecurrence
      :recurrence_id="recurrence_id"
      @updated="getRecurrences()"
    />
    <b-overlay :show="loading" opacity="0.99">
      <div class="container">
        <v-card>
          <v-card-title>
            <div class="col-auto">
              <v-btn
                class="v-primary mb-1"
                @click="$bvModal.show('new_recurrence')"
              >
                <span class="fa fa-plus"></span> Novo
              </v-btn>
            </div>
            <div class="col">Recorrência</div>
            <div class="col">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              />
            </div>
          </v-card-title>
          <v-card-text>
            <ErrorsMessages :errors="errors" />
            <div class="col">
              <v-data-table
                dense
                :headers="headers"
                :items="recurrences"
                :search="search"
                :footer-props="{
                  'items-per-page-options': [25, 75, 100],
                  'items-per-page-text': 'Mostrar',
                }"
                @click:row="openViewModal"
              >
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import NewRecurrence from "../templates/care/recurrence/NewRecurrence";
import ViewRecurrence from "../templates/care/recurrence/ViewRecurrence";

import ErrorsMessages from "../templates/components/ErrorsMessages";

import api from "../services/api";

import { formatDate } from "../functions/format";
import { adminData } from "../lib/functions";

export default {
  name: "Recurrence",
  components: {
    NavBar,
    NewRecurrence,
    ViewRecurrence,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],

      loading: false,

      search: "",
      headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Recorrência", value: "name" },
      ],
      recurrences: [],
      recurrence_id: "",
    };
  },
  created() {
    this.permissions = adminData().permissions;

    this.getRecurrences();
  },
  methods: {
    formatDate,
    async openViewModal(item) {
      this.recurrence_id = item.id;
      this.$bvModal.show("view_recurrence");
    },
    async getRecurrences() {
      try {
        this.loading = true;

        let response = await api.get("/admin/care/recurrences");
        let { error, errors, recurrences } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.recurrences = recurrences;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>